import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'amount'})
export class AmountPipe implements PipeTransform {

    transform(value: string): string {
        let amount = '';

        if (!value) {
            return '0,00';
        }

        value = value + '';

        const number = `${value}`.split(/[\.,]/);

        if (number.length === 2) {
            if (number[1].length < 2) {
                amount = number[0] + ',' + number[1] + '0';
            } else {
                amount = number[0] + ',' + number[1];
            }
        } else if (number.length === 1) {
            amount = number[0] + ',00';
        }

        /*SPACES NUMBER*/

        const arr = `${amount}`.split(',');
        amount = ',' + arr[1];

        const number_spaces = arr[0];

        let b = 0;
        for (let i = number_spaces.length; i > 0 ; --i) {
            amount = number_spaces.charAt(i - 1) + amount;
            ++b;
            if (b === 3) {
                b = 0;
                amount = ' ' + amount;
            }
        }
        return amount.trim();
    }
}
